import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useInputs } from '@bellawatt/use-inputs';
import { GasIcon, PencilIcon } from '../../assets/icons/icons';
import { useIntl } from 'react-intl';
import { formatAsCents } from '../../utils/formatters';
import EditAssumptionsDialog from '../EditAssumptionsDialog/EditAssumptionsDialog';
import ButtonInput from '../../components/inputs/ButtonInput';
import styled from '@emotion/styled';

const FlexRowBox = styled(Box)`
  display: flex;
  flex-direction: row;
`;

const FlexColBox = styled(Box)`
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 16px;
`;

const LabelBox = styled(Box)`
  color: ${(props) => props.theme.palette.common.secondaryGrey};
  text-align: left;
  line-height: 22px;
  margin-top: 39px;
`;

export default function AssumptionCard() {
  const { gasolinePrice, dieselPrice } = useInputs();
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const [openEdit, setOpenEdit] = useState(false);

  return (
    <Grid
      sx={{
        border: `1px solid ${theme.palette.common.borderGrey}`,
        borderRadius: '4px',
      }}
    >
      <FlexColBox pr="40px" pl="43px" pb="50px">
        <FlexRowBox id="header" pt="38px" justifyContent="end">
          <ButtonInput onClick={() => setOpenEdit(true)} variant="link">
            <PencilIcon />
            {formatMessage({ id: 'panels.assessment.editAssumption' })}
          </ButtonInput>
        </FlexRowBox>
        <FlexRowBox>
          <Box width="103px" height="99px">
            <GasIcon />
          </Box>
          <FlexColBox ml="28px">
            <LabelBox>{formatMessage({ id: 'panels.assessment.gasPrice' }).toUpperCase()}</LabelBox>
            <Box fontWeight="600">{formatAsCents(gasolinePrice)}</Box>
          </FlexColBox>
          <FlexColBox ml="156px">
            <LabelBox>
              {formatMessage({ id: 'panels.assessment.dieselPrice' }).toUpperCase()}
            </LabelBox>
            <Box fontWeight="600">{formatAsCents(dieselPrice)}</Box>
          </FlexColBox>
        </FlexRowBox>
      </FlexColBox>
      <EditAssumptionsDialog isOpen={openEdit} onClose={() => setOpenEdit(false)} />
    </Grid>
  );
}
